document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('#component-shop-skincare-menu');
  wrappers.forEach(function (wrapper) {
    const button = wrapper.querySelector('.button');
    button.addEventListener('click', function () {
      wrapper.classList.toggle('is-open');
    });
    button.addEventListener('blur', function (event) {
      if (!wrapper.contains(event.relatedTarget)) {
        wrapper.classList.remove('is-open');
      }
    });
  });
});
